import makePaginateReducer from './paginate'
import {
  GET_MESSAGES,
  GET_MESSAGE_LOADING,
  GET_MESSAGE_SUCCESS,
  GET_MESSAGE_FAILURE,
  MARK_MESSAGE_AS_READ_SUCCESS,
} from '../actions'

const paginationReducer = makePaginateReducer(GET_MESSAGES)

const viewedMessage = (prevState = { loading: false }, { type }) => {
  switch (type) {
    case GET_MESSAGE_LOADING:
      return {
        ...prevState,
        loading: true,
      }
    case GET_MESSAGE_SUCCESS:
    case GET_MESSAGE_FAILURE:
      return {
        ...prevState,
        loading: false,
      }
    default:
      return prevState
  }
}

const messagesData = (prevState, { type, payload }) => {
  switch (type) {
    case GET_MESSAGE_SUCCESS:
      return {
        ...prevState,
        [payload.id]: payload,
      }
    case MARK_MESSAGE_AS_READ_SUCCESS: {
      if (typeof prevState[payload] !== 'undefined') {
        return {
          ...prevState,
          [payload]: {
            ...prevState[payload],
            read: true,
          },
        }
      }
      return prevState
    }
    default:
      return prevState
  }
}

export default (prevState, action) => {
  // Handel pagination stuff
  const partialNewState = paginationReducer(prevState, action)

  // Messages specific logic
  return {
    ...partialNewState,
    data: messagesData(partialNewState.data, action),
    viewedMessage: viewedMessage(partialNewState.viewedMessage, action),
  }
}



// WEBPACK FOOTER //
// ./src/reducers/messages.js